/* /journaltest: the journal look's test, walled off from the real site. It opens the planner's test
   (/planner/?journaltest, see apps/planner/prototype/v9/journal38.js): a fresh student kept in that tab only, never
   saved to an account. The real planner and every other page stay exactly as they are. */
import { useEffect } from 'react';

export function JournalTest() {
  useEffect(() => { location.replace('/planner/?journaltest'); }, []);
  return null;
}
